export const matches = [
  {
    id: "m2026100901",
    date: "2026-10-09",
    time: "09:00",
    home: "lal",
    away: "gsw",
    status: "live",
    period: "第四节",
    clock: "06:12",
    homeScore: 98,
    awayScore: 95,
    venue: "加密竞技场球馆",
    referees: ["斯科特·福斯特", "托尼·布拉泽斯", "马克·戴维斯"],
    stage: "常规赛第 4 轮",
    region: "西部",
    intro: "西部太平洋赛区焦点战，湖人主场迎战勇士。两队本赛季均取得 3 胜 1 负，本场直接争夺分区排名。",
    events: [
      { time: "10:48", period: "第四节", type: "timeout", text: "勇士请求暂停，试图稳住节奏。" },
      { time: "09:35", period: "第四节", type: "score", text: "湖人内线强攻得手，分差拉开到 5 分。" },
      { time: "08:02", period: "第四节", type: "score", text: "勇士外线三分命中，将分差缩小到 2 分。" },
      { time: "07:10", period: "第四节", type: "foul", text: "湖人主力大前锋领到个人第 5 次犯规。" },
      { time: "06:12", period: "第四节", type: "info", text: "官方暂停，比赛进入最后 6 分钟决战阶段。" },
    ],
  },
  {
    id: "m2026100902",
    date: "2026-10-09",
    time: "10:30",
    home: "den",
    away: "okc",
    status: "live",
    period: "第三节",
    clock: "02:44",
    homeScore: 74,
    awayScore: 71,
    venue: "波尔球馆",
    referees: ["凯恩·菲茨杰拉德", "比尔·肯尼迪", "娜塔莉·萨戈"],
    stage: "常规赛第 4 轮",
    region: "西部",
    intro: "西北赛区内战，掘金坐镇主场对阵雷霆。两队近年交锋火花四溅，内线与外线的对位是本场看点。",
    events: [
      { time: "05:20", period: "第三节", type: "score", text: "雷霆快攻反击暴扣得手，反超比分。" },
      { time: "04:02", period: "第三节", type: "score", text: "掘金中锋篮下勾手命中，重新夺回领先。" },
      { time: "03:15", period: "第三节", type: "sub", text: "雷霆换上第二阵容，加强外线防守。" },
      { time: "02:44", period: "第三节", type: "timeout", text: "掘金请求暂停布置战术。" },
    ],
  },
  {
    id: "m2026100903",
    date: "2026-10-09",
    time: "11:00",
    home: "bos",
    away: "nyk",
    status: "live",
    period: "第二节",
    clock: "04:50",
    homeScore: 52,
    awayScore: 49,
    venue: "TD 花园球馆",
    referees: ["詹姆斯·卡珀斯", "泰勒·福特", "贾森·戈登"],
    stage: "常规赛第 4 轮",
    region: "东部",
    intro: "东部大西洋赛区强强对话，凯尔特人主场对阵尼克斯。两支争冠热门球队的正面碰撞，攻防节奏值得期待。",
    events: [
      { time: "06:30", period: "第二节", type: "score", text: "尼克斯后卫连续两记三分，追平比分。" },
      { time: "05:24", period: "第二节", type: "foul", text: "尼克斯内线吃到进攻犯规。" },
      { time: "04:50", period: "第二节", type: "info", text: "凯尔特人打出一波 7:0 小高潮。" },
    ],
  },
  {
    id: "m2026100904",
    date: "2026-10-09",
    time: "08:30",
    home: "phi",
    away: "mia",
    status: "finished",
    period: "已结束",
    clock: "00:00",
    homeScore: 112,
    awayScore: 108,
    venue: "富国银行中心球馆",
    referees: ["肖恩·赖特", "本·泰勒", "科特尼·柯克兰"],
    stage: "常规赛第 4 轮",
    region: "东部",
    intro: "东部两支防守强队交手，76人主场经过四节鏖战险胜热火。",
    events: [
      { time: "00:18", period: "第四节", type: "score", text: "76人后卫两罚全中锁定胜局。" },
      { time: "00:04", period: "第四节", type: "score", text: "热火压哨三分命中，仍以 4 分之差告负。" },
      { time: "00:00", period: "第四节", type: "info", text: "全场结束，76人 112:108 战胜热火。" },
    ],
  },
  {
    id: "m2026100905",
    date: "2026-10-09",
    time: "19:30",
    home: "dal",
    away: "phx",
    status: "upcoming",
    period: "未开始",
    clock: "—",
    homeScore: 0,
    awayScore: 0,
    venue: "美国航空中心球馆",
    referees: ["待定"],
    stage: "常规赛第 4 轮",
    region: "西部",
    intro: "西部西南赛区对阵太平洋赛区，独行侠主场迎战太阳，双方核心球员的直接对话备受关注。",
    events: [],
  },
  {
    id: "m2026100906",
    date: "2026-10-09",
    time: "20:00",
    home: "mil",
    away: "cle",
    status: "upcoming",
    period: "未开始",
    clock: "—",
    homeScore: 0,
    awayScore: 0,
    venue: "论坛之家球馆",
    referees: ["待定"],
    stage: "常规赛第 4 轮",
    region: "东部",
    intro: "东部中部赛区强强对话，雄鹿主场对阵骑士，两支冲击东部前四的球队狭路相逢。",
    events: [],
  },
  {
    id: "m2026100907",
    date: "2026-10-09",
    time: "21:00",
    home: "min",
    away: "hou",
    status: "upcoming",
    period: "未开始",
    clock: "—",
    homeScore: 0,
    awayScore: 0,
    venue: "目标中心球馆",
    referees: ["待定"],
    stage: "常规赛第 4 轮",
    region: "西部",
    intro: "西部西北赛区与西南赛区交锋，森林狼主场迎战火箭，年轻核心的成长对决值得期待。",
    events: [],
  },
  {
    id: "m2026100801",
    date: "2026-10-08",
    time: "09:30",
    home: "gsw",
    away: "sac",
    status: "finished",
    period: "已结束",
    clock: "00:00",
    homeScore: 121,
    awayScore: 117,
    venue: "大通中心球馆",
    referees: ["马克·林赛", "德里克·柯林斯", "艾米·博内尔"],
    stage: "常规赛第 3 轮",
    region: "西部",
    intro: "加州德比，勇士主场经过加时险胜国王，外线火力成为胜负手。",
    events: [
      { time: "00:00", period: "加时", type: "info", text: "加时赛结束，勇士 121:117 取胜。" },
    ],
  },
  {
    id: "m2026100802",
    date: "2026-10-08",
    time: "11:00",
    home: "nyk",
    away: "chi",
    status: "finished",
    period: "已结束",
    clock: "00:00",
    homeScore: 104,
    awayScore: 96,
    venue: "麦迪逊广场花园",
    referees: ["罗德尼·莫特", "贾斯汀·范杜恩", "克莱尔·奥博恩"],
    stage: "常规赛第 3 轮",
    region: "东部",
    intro: "尼克斯主场稳扎稳打，凭借第三节的一波攻势击败来访的公牛。",
    events: [
      { time: "00:00", period: "第四节", type: "info", text: "全场结束，尼克斯 104:96 取胜。" },
    ],
  },
  {
    id: "m2026101001",
    date: "2026-10-10",
    time: "10:00",
    home: "lal",
    away: "den",
    status: "upcoming",
    period: "未开始",
    clock: "—",
    homeScore: 0,
    awayScore: 0,
    venue: "加密竞技场球馆",
    referees: ["待定"],
    stage: "常规赛第 5 轮",
    region: "西部",
    intro: "湖人背靠背坐镇主场迎战掘金，内线对抗与战术执行力将决定比赛走势。",
    events: [],
  },
  {
    id: "m2026101002",
    date: "2026-10-10",
    time: "10:30",
    home: "okc",
    away: "sas",
    status: "upcoming",
    period: "未开始",
    clock: "—",
    homeScore: 0,
    awayScore: 0,
    venue: "佩科姆中心球馆",
    referees: ["待定"],
    stage: "常规赛第 5 轮",
    region: "西部",
    intro: "雷霆主场对阵马刺，两支年轻球队的速度与天赋碰撞。",
    events: [],
  },
  {
    id: "m2026101101",
    date: "2026-10-11",
    time: "08:00",
    home: "bos",
    away: "mil",
    status: "upcoming",
    period: "未开始",
    clock: "—",
    homeScore: 0,
    awayScore: 0,
    venue: "TD 花园球馆",
    referees: ["待定"],
    stage: "常规赛第 5 轮",
    region: "东部",
    intro: "东部冠军热门正面交锋，凯尔特人主场对阵雄鹿，锋线与内线的对话看点十足。",
    events: [],
  },
  {
    id: "m2026101102",
    date: "2026-10-11",
    time: "09:00",
    home: "lac",
    away: "lal",
    status: "upcoming",
    period: "未开始",
    clock: "—",
    homeScore: 0,
    awayScore: 0,
    venue: "直觉穹顶球馆",
    referees: ["待定"],
    stage: "常规赛第 5 轮",
    region: "西部",
    intro: "洛杉矶同城德比，快船与湖人的城市内战，球市热度与竞技悬念兼具。",
    events: [],
  },
  {
    id: "m2026101103",
    date: "2026-10-11",
    time: "11:00",
    home: "mia",
    away: "cle",
    status: "upcoming",
    period: "未开始",
    clock: "—",
    homeScore: 0,
    awayScore: 0,
    venue: "卡塞雅中心球馆",
    referees: ["待定"],
    stage: "常规赛第 5 轮",
    region: "东部",
    intro: "热火主场迎战骑士，两队的团队防守与阵地进攻将展开拉锯。",
    events: [],
  },
  {
    id: "m2026100701",
    date: "2026-10-07",
    time: "10:00",
    home: "phx",
    away: "dal",
    status: "finished",
    period: "已结束",
    clock: "00:00",
    homeScore: 118,
    awayScore: 110,
    venue: "足迹中心球馆",
    referees: ["斯科特·福斯特", "迈克尔·史密斯", "布伦达·帕内尔"],
    stage: "常规赛第 2 轮",
    region: "西部",
    intro: "太阳主场凭借第三节的强势发挥击败独行侠，取得赛季第二胜。",
    events: [
      { time: "00:00", period: "第四节", type: "info", text: "全场结束，太阳 118:110 取胜。" },
    ],
  },
  {
    id: "m2026100702",
    date: "2026-10-07",
    time: "09:00",
    home: "hou",
    away: "min",
    status: "finished",
    period: "已结束",
    clock: "00:00",
    homeScore: 99,
    awayScore: 105,
    venue: "丰田中心球馆",
    referees: ["托尼·布拉泽斯", "贾斯汀·范杜恩", "克莱尔·奥博恩"],
    stage: "常规赛第 2 轮",
    region: "西部",
    intro: "森林狼客场挑战火箭，末节的关键防守帮助客队锁定胜局。",
    events: [
      { time: "00:00", period: "第四节", type: "info", text: "全场结束，森林狼 105:99 取胜。" },
    ],
  },
];